import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface Stat {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

interface StatsProps {
  stats: Stat[];
  light?: boolean;
  className?: string;
}

const Stats: React.FC<StatsProps> = ({ stats, light = false, className }) => {
  return (
    <div
      className={cn(
        'grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12',
        className
      )}
    >
      {stats.map((stat, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          className="text-center"
        >
          {stat.icon && (
            <div
              className={cn(
                'inline-flex items-center justify-center w-14 h-14 rounded-full mb-4',
                light ? 'bg-primary-foreground/10' : 'bg-secondary/10'
              )}
            >
              <div className={light ? 'text-secondary' : 'text-secondary'}>
                {stat.icon}
              </div>
            </div>
          )}
          <div
            className={cn(
              'text-4xl md:text-5xl font-heading font-bold mb-2',
              light ? 'text-primary-foreground' : 'text-foreground'
            )}
          >
            {stat.value}
          </div>
          <div
            className={cn(
              'text-sm md:text-base font-body',
              light ? 'text-primary-foreground/80' : 'text-text-light'
            )}
          >
            {stat.label}
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default Stats;
